import { render } from "./phone_step.vue?vue&type=template&id=732a04f1"
import script from "./phone_step.vue?vue&type=script&lang=js"
export * from "./phone_step.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__